var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList,attrs:{"for":_vm.isFor}},[_vm._t("default"),(_vm.required)?_c('span',[_vm._v(_vm._s(' ')+"*")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }